import { useEffect, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { getApi } from "../../services/api/globalApi";
import Pagination from "../../components/common/pagination/Pagination";
import { useNavigate } from "react-router";
import { digitsThree } from "../../utils/price";
import { shippingListColumns } from "../../constant/tablesColumns/tablesColums";

export default function ProductShippingList() {
  const [productData, setProductData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const getProductShipping = async (params) => {
    const path = "admin/shipings";
    try {
      const response = await getApi({ path, params: { ...params } });
      setProductData(response?.data?.result.data);
      setPagination(response?.data?.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getProductShipping({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getProductShipping(allFilter);
  };

  const data = [];

  productData?.map((item) =>
    data.push({
      key: item._id,
      id: item._id,
      name: item.name || "",
      faPrice: `${digitsThree(item.price)}` || "",
      price: item.price || "",
      faIsDefault: item.isDefault ? "بله" : "خیر",
      isDefault: item.isDefault ? "true" : "false",
      faFreeForAll: item.freeForAll ? "بله" : "خیر",
      freeForAll: item.freeForAll ? "true" : "false",
      freeForRoles: item?.freeForRoles?.roles || [],
      freeForRolesNe: item?.freeForRoles?.neProducts || [],
      freeGteThanPrice: item?.freeGteThanPrice?.value || [],
      freeGteThanPriceNe: item?.freeGteThanPrice?.neProducts || [],
      cashOnDeliveryGteWeight: item?.cashOnDeliveryGteWeight?.value || "",
      faStatus:
        (item.status === "active"
          ? "فعال"
          : item.status === "pending"
          ? "انتظار"
          : "غیرفعال") || "pending",
      status: item.status,
    })
  );

  const navigate = useNavigate();

  const editProduct = (singleShipping) => {
    navigate("/edit-product-shipping", { state: singleShipping });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={"لیست حمل و نقل"} />

      <Table columns={shippingListColumns} rows={data} onEdit={editProduct} />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
    </div>
  );
}
